import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Slider from "../components/slider"
import Seo from "../components/seo"
import ReactLinkify from "react-linkify"
import PostList from "../components/post_list_alpha"

const bravetart = ({ data }) => {

  const slider_data = data.allMdx.nodes.map((x) =>  x);

  const first_video = slider_data.shift();

  const metaData = [{
    name: "keywords",
    content: first_video.frontmatter.keywords,
  }];

  const image = getImage(first_video.fields.thumbnail);

  const description = "Watch me cook recipes from Stella Parks' Bravetart cookbook.";

  return (
    <Layout>
      <Seo title="Bravetart" meta={metaData} image={image} description={description}/>
      <h1>Bravetart</h1>
      <p>
        Stella Parks was the well-respected pastry editor at <a href="https://www.seriouseats.com/">Serious
        Eats from 2016 until 2019, and had contributed to the site since 2011.</a> She is CIA trained, and 
        does for pastry what <a href="http://www.kenjilopezalt.com/">J. Kenji López-Alt</a> does for...
        everything else food?
      </p>
      <p>
        After developing all of the recipes for and writing this book, which has won a <a href="https://www.jamesbeard.org/">James 
        Beard Award</a>, and touring for it while also developing recipes for Serious Eats, she took a step back from everything 
        for what she calls a "hermit era." She has come back to the public recently,&nbsp;
        <a href="https://www.177milkstreet.com/stories/09-2024-bravetart-is-back-opinionated-as-ever">briefly</a>, 
        for an episode of Milk Street Radio. There she says she has been relearning what baking is for most
        people, rather than a cookbook author and cooking site editor. She also apparently played video 
        games and watched Battle Star Galactica, as one does.
      </p>
      {first_video && (
        <div className="featured-video">
          <h2>{first_video.frontmatter.title}</h2>
          <Link to={first_video.fields.slug}>
            {first_video.fields.thumbnail && 
              <GatsbyImage image={getImage(first_video.fields.thumbnail)} alt={first_video.frontmatter.title + ' from ' + first_video.frontmatter.source}/> 
            }
          </Link>
          <figcaption>
            {first_video.frontmatter.description && (
              <ReactLinkify>{first_video.frontmatter.description.split('\n').shift()}</ReactLinkify>
            )}
          </figcaption>
        </div>
      )}
      {slider_data.length > 0 &&  (
      <div className="video-slider">
        <h2>More Recent Videos</h2>
        <Slider data={slider_data} />
      </div>)}
      <div className="all-videos">
        <h2>All Videos</h2>
        <PostList data={data.allMdx.nodes} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMdx(
      filter: { frontmatter: { keywords: { regex: "/bravetart/" } } }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      nodes {
        fields {
          youtubeId
          slug
          thumbnail {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                layout: FULL_WIDTH)
            }
          }
        }
        frontmatter {
          title
          source
          date(formatString: "MMMM D, Y")
          video_url
          description
          keywords
        }
      }
    }
  }
`

export default bravetart;
